<template>
  <div>
    <div
        ref="chart"
        class="css-svg-container"
    />
  </div>
</template>
<script>
import bb, {
  area,
  areaLineRange,
  areaSpline,
  areaSplineRange,
  areaStep,
  bar,
  bubble,
  donut,
  gauge,
  line,
  pie,
  radar,
  scatter,
  spline,
  step,
  // interaction modules
  selection, subchart, zoom
} from "billboard.js"
import "billboard.js/dist/billboard.css";
import "billboard.js/dist/theme/insight.css"

export default {
  name:  'graphLineChart',
  props: {
    pDataSet:                 {},
    switcherNewPropsHaveCome: true
  },
  data() {
    return {
      dDataSet:          [],
      chart:             {},
      previousDataNames: []
    }
  },
  async mounted() {
    await this.$nextTick();
    this.draw();
  },
  watch:   {
    switcherNewPropsHaveCome: {
      deep:    true,
      handler: function (newVal, oldVal) {
        this.datasetChanged();
      }
    }
  },
  methods: {
    draw() {
      this.chart = bb.generate({
            bindto:     this.$refs.chart,
            responsive: false,
            data:       {
              type:    line(),
              columns: this.dDataSet
            },
            zoom:       {
              enabled: zoom()
            }
          }
      );
    },
    datasetChanged() {
      const _this            = this;
      // #####
      //this.previousDataNames = this.dDataSet.map(el => el[0]);
      // #####
      this.dDataSet          = this.pDataSet;
      //this.chart.flush(false);
      // #####
      _this.chart.destroy();
      _this.draw();
      return this;
      // #####
      // _this.chart
      //     .load({
      //       columns: _this.dDataSet,
      //       unload:  this.previousDataNames,
      //       done:    () => {
      //         //_this.chart.flush(true);
      //         _this.chart.unzoom();
      //       }
      //     })      // #####
    }
  }
}
</script>
<style scoped lang="scss">

</style>
